export const FullWidth = `
	flex-grow: 0;
	flex-shrink: 0;
	width: 100%;
	@media (min-width: 540px) { width: 460px; }
	@media (min-width: 660px) { width: 620px; }
	@media (min-width: 980px) { width: 940px; }
	@media (min-width: 1280px) { width: 1160px; }
	@media (min-width: 1600px) { width: 1400px; }
`;